<script>
export default {
  functional: true,
  render(createElement, context) {
    const type = 'is-navy'
    const data = {
      ...context.data,
      class:
        '!tw-h-[32px] tw-font-normal lg:tw-font-medium tw-text-sm lg:!tw-h-[40px]',
      props: {
        type,
        outlined: true,
      },
    }

    return createElement('b-button', data, context.children)
  },
}
</script>
